/**
 * Debug utilities for conditional console logging.
 * All console output is controlled by the REACT_APP_DEBUG environment variable.
 * Set REACT_APP_DEBUG=true in .env to enable debug logging.
 */

const isDebugEnabled = (): boolean => {
  return process.env.REACT_APP_DEBUG === 'true';
};

/**
 * Conditional console.log - only outputs when REACT_APP_DEBUG=true
 */
export const debugLog = (...args: unknown[]): void => {
  if (isDebugEnabled()) {
    console.log(...args);
  }
};

/**
 * Conditional console.warn - only outputs when REACT_APP_DEBUG=true
 */
export const debugWarn = (...args: unknown[]): void => {
  if (isDebugEnabled()) {
    console.warn(...args);
  }
};

/**
 * Conditional console.error - only outputs when REACT_APP_DEBUG=true
 */
export const debugError = (...args: unknown[]): void => {
  if (isDebugEnabled()) {
    console.error(...args);
  }
};
